
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AddServiceCompany from "@/components/service-companies/AddServiceCompany.vue";
import SimpleDialog from "@/components/SimpleDialog.vue";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
  components: { SimpleDialog, AddServiceCompany },
})
export default class ServiceCompanies extends Vue {

  @Getter private envCompanyId: number | null;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private page: number = 1;
  private itemsPerPage: number = 10;
  private search: string = "";
  private loading: boolean = false;
  private deletingServiceCompany: any = null;

  private serviceCompaniesList: any[] = [];
  private totalItem: number = 0;

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  private headers: object[] = [
    { text: this.$t("company.name"), value: "name", sortable: false },
    { text: this.$t("company.siret"), value: "siret", sortable: false },
    { value: "action", sortable: false },
  ];

  // Business functions

  private getServiceCompaniesList() {
    this.loading = true;
    return this.$store.dispatch("companies/getServiceCompaniesList", {
      companyId: this.envCompanyId,
      search: this.search || null,
      page: this.page,
      itemsPerPage: this.itemsPerPage,
    })
      .then((data) => {
        this.serviceCompaniesList = data.rows;
        this.totalItem = data.count;
      })
      .finally(() => { this.loading = false; });
  }

  private async removeServiceCompany(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("companies/removeServiceCompany", {
      clientCompanyId: this.envCompanyId,
      serviceCompanyId: this.deletingServiceCompany.id,
    }).then(() => {
      this.reset();
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$i18n.t("ServiceCompanies.removed"),
      });
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loading = false;
    });
  }

  // Common functions

  private reset() {
    this.page = 1;
    this.itemsPerPage = 10;
    this.search = "";
    this.loading = false;
    this.deletingServiceCompany = null;
    this.getServiceCompaniesList();
  }

  private hasRight(right: string): boolean {
    return this.canDoInEnvCompany(right);
  }

  /**
   * Handles options for the data table.
   *
   * @param {Object} event - The event object containing the page and itemsPerPage values.
   * @return {void}
   */
  private dataTableHandleOptions(event) {
    this.page = event.page;
    this.itemsPerPage = event.itemsPerPage;
    this.getServiceCompaniesList();
  }

  /**
   * Description: Handles the key press event for the 'Enter' key.
   *
   * @param {object} e - The event object representing the key press.
   *
   * @return {void}
   */
  private enterKeyPress(e) {
    if (e.keyCode === 13) {
      this.searchHandler();
    }
  }

  /**
   * Resets the search page to 1 and retrieves the Build Bing List.
   *
   * @returns {void}
   */
  private searchHandler(): void {
    this.page = 1;
    this.getServiceCompaniesList();
  }

}
